const RESET_LAYER = 'reset';

let cachedResetCss: string | null = null;

/**
 * The package reset (`@layer reset`) as CSS text, copied from the page's style sheets: a shadow root doesn't get
 * document styles, and the bundled reset has no URL to link. Empty when the layer isn't found.
 */
export function getResetCss(): string {
    if (cachedResetCss !== null) {
        return cachedResetCss;
    }

    for (const sheet of Array.from(document.styleSheets)) {
        let rules: CSSRuleList;

        try {
            rules = sheet.cssRules;
        } catch {
            // A cross-origin sheet can't be read.
            continue;
        }

        for (const rule of Array.from(rules)) {
            if (rule instanceof CSSLayerBlockRule && rule.name === RESET_LAYER) {
                cachedResetCss = rule.cssText;
                return cachedResetCss;
            }
        }
    }

    return '';
}
